import BaseService from "services/BaseService";

class MasterFolderService extends BaseService {
  list = async () => {
    return await this._api.post("master/folder/list");
  };

  create = async ({ name, parent_id }) => {
    return await this._api.post("master/folder/create", { name, parent_id });
  };

  update = async ({ id, name, parent_id }) => {
    return await this._api.post("master/folder/update", { id, name, parent_id });
  };

  delete = async (id) => {
    return await this._api.post("master/folder/delete", { id });
  };
}

export default MasterFolderService;
